export enum BlockPaymentEnum {
  feeAgreement = 1,
  editPersonalData = 2,
}
